import { lazy, Suspense, useEffect, useState } from "react";
import { prefetchGridSettings, useGridSettingsVisible } from "./hooks";
import { ModalFloating } from "../components/ModalFloating";
import { ModeToggle } from "./ModeToggle";
import { Button } from "../ui";

const LazySettings = lazy(() => import("./Settings"));

export function CollapsibleSettings() {
  const [isGridSettingsVisible, setIsGridSettingsVisible] = useGridSettingsVisible();
  const [isContentReady, setIsContentReady] = useState(false);

  useEffect(() => {
    if (!isGridSettingsVisible) {
      setIsContentReady(false);
      return;
    }

    let cancelled = false;
    void prefetchGridSettings().then(() => {
      if (!cancelled) setIsContentReady(true);
    });

    return () => {
      cancelled = true;
    };
  }, [isGridSettingsVisible]);

  // Check if we need to reopen settings after re-authentication
  useEffect(() => {
    const shouldShowPasswordForm = sessionStorage.getItem("changePasswordAfterAuth");
    if (shouldShowPasswordForm === "true") {
      setIsGridSettingsVisible(true);
    }
  }, [setIsGridSettingsVisible]);

  if (!isGridSettingsVisible || !isContentReady) return null;

  return (
    <ModalFloating
      data-testid="settings-modal"
      title="Settings"
      width={576}
      height={576}
      onClose={() => setIsGridSettingsVisible(false)}
      footer={
        <>
          <ModeToggle />
          <div className="flex-1" />
          <Button buttonType="closePrimary" onClick={() => setIsGridSettingsVisible(false)}>
            Close
          </Button>
        </>
      }
    >
      <Suspense fallback={null}>
        <LazySettings />
      </Suspense>
    </ModalFloating>
  );
}
